// extracted by mini-css-extract-plugin
export default {"customBtn":"button_customBtn__M0Lle","WideButton":"button_WideButton__jCc1X","activeBtn":"button_activeBtn__hUEhY"};